import axios from 'axios';
import momentTimezone from 'moment-timezone';
import {
  getAccessToken
} from './auth';
import Promise from 'promise-polyfill';

export {
  getGlobalFunnel,
  getKeywords,
  getSummaryWeekly,
  getSummaryMonthly,
  getWeeklySnapshot,
  getMonthlySnapshot,
  getGlobalKeywords,
  getNiviFacilities,
  getNiviFacilitityById,
  getNiviLocations,
  getNiviGeojsons,
  getKmhflFacility,
  getUnredeemedReferralsWithLocationID,
  getUnredeemedReferralsWithoutLocationID,
  getWeeklyUnredeemedReferralsWithLocationID,
  getWeeklyUnredeemedReferralsWithoutLocationID,
  getMonthlyUnredeemedReferralsWithLocationID,
  getMonthlyUnredeemedReferralsWithoutLocationID
};

function makeRequest(url, timeout) {
  const headers = {
    Authorization: `Bearer ${getAccessToken()}`
  };
  if (timeout) {
    headers.timeout = timeout * 1000;
  }
  return axios.get(url, {
    headers
  });
}

function getGlobalFunnel() {
  const url = `${process.env.api_endpoint}/api/funnel/global`;
  return makeRequest(url)
}

function getUnredeemedReferralsWithLocationID() {
  const url = `${process.env.NIVI_REFERRAL_API}/cluster-unredeemed-referrals`;
  return axios.get(url);
}

function getUnredeemedReferralsWithoutLocationID() {
  const url = `${process.env.NIVI_REFERRAL_API}/cluster-unredeemed-referrals?nolocation=1`;
  return axios.get(url);
}

function getWeeklyUnredeemedReferralsWithLocationID() {
  const startDate = moment().startOf('isoWeek').format("YYYY-MM-DD");
  const endDAte = moment().endOf('isoWeek').format("YYYY-MM-DD");
  const url = `${process.env.NIVI_REFERRAL_API}/cluster-unredeemed-referrals/${startDate}/${endDAte}`;
  return axios.get(url);
}

function getWeeklyUnredeemedReferralsWithoutLocationID() {
  const startDate = moment().startOf('isoWeek').format("YYYY-MM-DD");
  const endDAte = moment().endOf('isoWeek').format("YYYY-MM-DD");
  const url = `${process.env.NIVI_REFERRAL_API}/cluster-unredeemed-referrals/${startDate}/${endDAte}?nolocation=1`;
  return axios.get(url);
}

function getMonthlyUnredeemedReferralsWithLocationID() {
  const startDate = moment().startOf('month').format("YYYY-MM-DD");
  const endDAte = moment().endOf('month').format("YYYY-MM-DD");
  const url = `${process.env.NIVI_REFERRAL_API}/cluster-unredeemed-referrals/${startDate}/${endDAte}`;
  return axios.get(url);
}

function getMonthlyUnredeemedReferralsWithoutLocationID() {
  const startDate = moment().startOf('month').format("YYYY-MM-DD");
  const endDAte = moment().endOf('month').format("YYYY-MM-DD");
  const url = `${process.env.NIVI_REFERRAL_API}/cluster-unredeemed-referrals/${startDate}/${endDAte}?nolocation=1`;
  return axios.get(url);
}

function getKeywords() {
  const url = `${process.env.keywords_endpoint}/keywords`
  // const url = `https://guxn0tuakf.execute-api.eu-central-1.amazonaws.com/Production/keywords`;
  return axios.get(url);
}

function getSummaryWeekly() {
  const url = `${process.env.api_endpoint}/api/funnel/global/period/weekly`;
  return makeRequest(url);
}

function getSummaryMonthly() {
  const url = `${process.env.api_endpoint}/api/funnel/global/period/monthly`;
  return makeRequest(url);
}

function getWeeklySnapshot() {
  const url = `${process.env.api_endpoint}/api/funnel/global/period/weekly/12`;
  return makeRequest(url);
}

function getMonthlySnapshot() {
  const url = `${process.env.api_endpoint}/api/funnel/global/period/monthly/12`;
  return makeRequest(url);
}

function getGlobalKeywords() {
  const url = `${process.env.api_endpoint}/api/keywords/global`;
  return makeRequest(url, 60);
}

function getNiviFacilities() {
  const url = `${process.env.facilities_endpoint}/facilities`
  // return axios.get(url);
  return makeRequest(url)
}

function getNiviFacilitityById(id) {
  const url = `${process.env.facilities_endpoint}/facilities/` + id
  // return axios.get(url);
  return makeRequest(url)
}

function getKmhflFacility(code) {
  const url = `${process.env.facilities_endpoint}/kmhfl?code=` + code;
  return axios.get(url);
  // return makeRequest(url)
}

function getNiviLocations() {
  const url = `${process.env.LOCATIONS_API}`;
  return axios.get(url);
  // return makeRequest(url)
}

function getNiviGeojsons() {
  const url = `${process.env.GEOJSONS_API}`;
  return axios.get(url);
  // return makeRequest(url)
}



//////////////////
// WEBPACK FOOTER
// ./utils/stats.js
// module id = GEZq
// module chunks = 1